import React from 'react';
import AuthService from 'services/AuthService';
import Header from 'components/layout/header/Header';
import Footer from 'components/layout/footer/Footer';
import { Route, Redirect } from 'react-router-dom';
import { GlobalConsumer } from 'context/GlobalProvider';
import ModalComplete from 'components/extensions/modal/ModalComplete';
import GlobalLoader from 'components/common/loader/GlobalLoader';
import Toast from 'components/ui/toast/Toast';
import { RoutesBase } from './constants-routes';

const Auth = new AuthService();

const DefaultLayoutPrivateLoginRedirect = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={matchProps =>
      Auth.loggedIn() === true ? (
        <GlobalConsumer>
          {context => {
            return (
              <>
                <div className="main">
                  <Header />
                  <main>
                    <Component {...matchProps} context={context} />
                  </main>
                  <Footer {...matchProps} context={context} />
                </div>
                <ModalComplete context={context} />
                <GlobalLoader context={context} />
                <Toast />
              </>
            );
          }}
        </GlobalConsumer>
      ) : (
        <Redirect
          {...matchProps}
          to={{
            pathname: `/${RoutesBase.login}/acesso/`,
            search: matchProps.location.search,
            state: {
              urlRetorno: `${matchProps.location.pathname}${
                matchProps?.location?.search ? `${matchProps.location.search}` : ''
              }`,
              ...(matchProps.location.state as any),
            },
          }}
        />
      )
    }
  />
);

export default DefaultLayoutPrivateLoginRedirect;
